import React from 'react';
import './PolicyPages.css';

const ShippingDelivery = () => {
  return (
    <div className="policy-page-container">
      <div className="policy-content">
        <h1 className="policy-title">Shipping & Delivery Policy – House of Microgreens</h1>
        <p className="policy-updated">Last updated: 25 November 2025</p>
        
        <p className="policy-intro">
          We aim to deliver fresh microgreens to your doorstep on time and in perfect condition.
        </p>

        <section className="policy-section">
          <h2>1. Serviceable Locations</h2>
          <p>
            We currently deliver to select areas in and around Bangalore, Karnataka.
            Users must check availability by entering their 6-digit PIN code on the website.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Delivery Schedule</h2>
          <ul>
            <li>Delivery days and timings depend on your location and subscription type.</li>
            <li>Microgreens are harvested fresh before dispatch.</li>
            <li>Delivery delays may occur due to traffic, weather, or operational challenges.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Delivery Process</h2>
          <ul>
            <li>You will receive notifications regarding delivery status.</li>
            <li>Ensure your address, PIN code, and contact number are correct.</li>
            <li>If the delivery attempt fails (unreachable, incorrect address, etc.), the order may be marked as delivered or wasted due to perishability.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Shipping Charges</h2>
          <ul>
            <li>Shipping charges (if any) will be displayed at checkout.</li>
            <li>Subscription orders may have free/discounted delivery depending on the plan.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Quality Assurance</h2>
          <p>
            Our microgreens are freshly grown, harvested, and delivered the same day.
            If you experience any issue, please contact us immediately with photos/videos.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ShippingDelivery;
